// @ts-strict-ignore
import { createSelector } from 'reselect';

import type { Bounds, CanvasSize } from 'flow/service/graph';
import {
  getCanvasTranslateExtent,
  getGraphBounds,
  getSimpleIslandMode,
  isGraphRequiredSpaceLargerThanCanvas,
} from 'flow/service/graph';

import type { State } from '~/store';

import { selectIsComplexOutcomeIslandOpen, selectIsNodeEditorDrawerOpen } from './general';
import { selectLayOutedGraph } from './graph';


export const selectGraphBounds = createSelector(
  [
    selectLayOutedGraph,
  ],
  (graph): Bounds => getGraphBounds(graph),
);


const selectCanvasSize = createSelector(
  [
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.width,
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.height,
  ],
  (width, height): CanvasSize => ({ width, height }),
);


export const selectCanvasPosition = createSelector(
  [
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.x,
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.y,
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.zoom,
  ],
  (x, y, zoom) => ({ x, y, zoom }),
);


export const selectCanvasRect = createSelector(
  [
    selectCanvasSize,
    selectCanvasPosition,
  ],
  (
    canvasSize,
    canvasPosition,
  ) => ({
    ...canvasSize,
    ...canvasPosition,
  }),
);

export const selectCanvasTranslateExtent = createSelector(
  [
    selectCanvasSize,
    selectIsComplexOutcomeIslandOpen,
    selectIsNodeEditorDrawerOpen,
    selectGraphBounds,
  ],
  (canvasSize, isComplexIslandOpen, isNodeEditorDrawerOpen, graphBounds) => (
    getCanvasTranslateExtent({
      canvasSize,
      graphBounds,
      isComplexIslandOpen,
      isNodeEditorDrawerOpen,
    })
  ),
);

export const selectSimpleIslandMode = createSelector(
  [
    selectGraphBounds,
    selectCanvasRect,
  ],
  (graphBounds, canvasRect) => getSimpleIslandMode(graphBounds, canvasRect),

);


export const selectIsGraphLargerThanCanvas = createSelector(
  [
    selectGraphBounds,
    selectCanvasSize,
  ],
  /**
   * todo BUILD-2907: eventually, selecting the canvas translate extent and comparing it against
   * the canvas width should be enough and the invoked function in this selector could be deleted.
   */
  (graphBounds, canvasSize) => isGraphRequiredSpaceLargerThanCanvas(graphBounds, canvasSize),
);
